import axiosInstance from "../api/axiosInstance";
import { PRE_DISPATCHES } from "../constants/API_URLs";

export const getPreDispatches = (params: any): Promise<any> => {
  return axiosInstance.get(PRE_DISPATCHES, { params });
};

export const updatePreDispatches = (data: any): Promise<any> => {
  return axiosInstance.patch(`${PRE_DISPATCHES}`, data);
};

export const exportExcelPreDispatches = (params: any): Promise<any> => {
  return axiosInstance.get(`${PRE_DISPATCHES}/export/excel`, {
    params,
    responseType: "blob",
  });
};
